import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {OrdineEsolver} from '../../_models/OrdineEsolver';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';
import {LocalService} from '../../_services/local.service';
import {SaveMessage} from '../../_helpers/save-message';
import {SearchResult} from '../../_models/SearchResult';
import {Subscription} from 'rxjs';
import {OrdineEsolverGroup} from '../../_models/OrdineEsolverGroup';
import {FilterItem} from '../../_models/FilterItem';
import {GroupEsolverResult} from '../../_models/GroupEsolverResult';
import {HubMonitorService} from '../../_services/hub-monitor.service';

@Component({
    selector: 'app-ordini-esolver-groupbymany',
    templateUrl: './ordini-esolver-groupbymany.component.html',
    styleUrls: ['./ordini-esolver-groupbymany.component.scss'],
    standalone: false
})
export class OrdiniEsolverGroupbymanyComponent  implements OnInit, OnChanges, OnDestroy {
  @Input() filters: FilterItem[] = [];
  @Input() groupingContext = '';
  @Output() ordineEsolverGroupSended = new EventEmitter<OrdineEsolverGroup>();
  sortDirection = true;
  sortKey = 'dataTermine';
  ordiniGroups: GroupEsolverResult<OrdineEsolver>[] = [];
  page = 0;
  count = 20;
  loadMore = false;
  loading = false;
  hasLoaded = false;
  selectedOrdiniGroup: OrdineEsolverGroup;
  subscription: Subscription;
  private requestToken = 0;
  constructor(
    private organizzazioniService: OrganizzazioniService,
    private localService: LocalService,
    private saveMessage: SaveMessage,
    private hubMonitorService: HubMonitorService) {}

  ngOnInit() {
    this.selectedOrdiniGroup = this.localService.getEmptyOrderEsolver();
    this.selectedOrdiniGroup.ordini = [];
    this.subscription = this.localService.searchText.subscribe((_value: string) => {
      this.getOrdiniEsolverGroupByMany(false);
    });
    this.subscription.add(this.localService.handleRefresh.subscribe(() => this.getOrdiniEsolverGroupByMany(false)));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.groupingContext && !changes.groupingContext.firstChange && this.subscription) {
      this.selectedOrdiniGroup.ordini = [];
      void this.getOrdiniEsolverGroupByMany(false);
    }
  }

  getOrdiniEsolverGroupByMany = async (add: boolean): Promise<void> => {
    if (add && this.loading) {
      return;
    }
    const token = ++this.requestToken;
    const groupColumns = this.organizzazioniService.groupColumnsArray;
    this.hasLoaded = false;
    if (groupColumns.length === 0) {
      this.ordiniGroups = [];
      this.page = 0;
      this.loadMore = false;
      this.loading = false;
      if (this.selectedOrdiniGroup) {
        this.selectedOrdiniGroup.ordini = [];
      }
      return;
    }
    this.loadMore = true;
    this.loading = true;
    if (!add) {
      this.ordiniGroups = [];
      this.page = 0;
    } else {
      this.page += 1;
    }
    const search = this.localService.searchText.getValue().toString();
    try {
      const _result: SearchResult<GroupEsolverResult<OrdineEsolver>> = await this.localService.getOrdiniGroupByManyEsolver(this.organizzazioniService.organizzazioneId, this.organizzazioniService.gruppoCodice,
        this.organizzazioniService.organizzazioneCodice, search,this.page, this.count,
        this.sortKey, this.sortDirection, true, true, this.filters, groupColumns);
      if (token !== this.requestToken) {
        return;
      }
      if (_result.hasErrors) {
        throw new Error('Il raggruppamento non è disponibile.');
      }
      this.hasLoaded = true;
      if (_result.totalCount === 0) {
        this.ordiniGroups = [];
        this.loadMore = false;
        return;
      }
      if (!add) {
        this.ordiniGroups = _result.result;
      } else {
        _result.result.forEach((ord: GroupEsolverResult<OrdineEsolver>) => this.ordiniGroups.push(ord));
      }
      this.loadMore = _result.totalCount > this.ordiniGroups.length;
    } catch {
      if (token === this.requestToken) {
        this.saveMessage.messageError("Ci sono problemi con il raggruppamento gerarchico.");
      }
    } finally {
      if (token === this.requestToken) {
        this.loading = false;
      }
    }
  };

  addOrdiniEsolver = (ordiniEsolver: OrdineEsolver[]) => ordiniEsolver.forEach((_ordineEsolver: OrdineEsolver) => {
    if (this.selectedOrdiniGroup.ordini.indexOf(_ordineEsolver) < 0) {
      this.selectedOrdiniGroup.ordini.push(_ordineEsolver);
    }
  });

  confirmOrdineEsolverGroup = () => this.ordineEsolverGroupSended.emit(this.selectedOrdiniGroup);

  openHubMonitor(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.hubMonitorService.requestOpenHubMonitor();
  }

  ngOnDestroy() {
    this.requestToken += 1;
    this.subscription.unsubscribe();
  }
}
